import { Capacitor } from "@capacitor/core";
import { Subscriptions } from "capacitor-subscriptions";
import { useEffect } from "react";
import { BUNDLE_ID, GOOGLE_VERIFY_ENDPOINT } from "../../Constants";
import DataController from "@controllers/DataController";

export const useGoogleVerification = () => {
  useEffect(() => {
    const googleVerification = async (): Promise<void> => {
      try {
        if (!(await DataController.isWebAsync()) && Capacitor.getPlatform() === "android") {
          Subscriptions.setGoogleVerificationDetails({
            googleVerifyEndpoint: GOOGLE_VERIFY_ENDPOINT,
            bid: BUNDLE_ID,
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    googleVerification();
  }, []);
};
